import React, {useCallback, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCertificate, faChevronDown, faChevronUp, faCirclePlus} from "@fortawesome/free-solid-svg-icons";
import PositionCertification from "./PositionCertification";
import {certificationTypeDefault} from "../../../../defaults/Items";

const PositionCertificationsCard = ({state, certificationsList}) => {
  const currentItem = state.currentItem;
  const requiredCertifications = currentItem?.requiredCertifications || [];
  const setCurrentItem = state.setCurrentItem;
  const setItemChanged = state.setItemChanged;
  const itemChanged = state.itemChanged;
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  const filteredCertificationsList = certificationsList.filter(
    certification => !requiredCertifications.some(item => item.id === certification.id)
  );

  const addCertification = () => {
    const existingIds = requiredCertifications.map(certification => certification.id);
    let newId = -1;
    while (existingIds.includes(newId)) newId--;
    const newCertification = {...certificationTypeDefault, id: newId, name: "---Wybierz---"};
    setCurrentItem({...currentItem, requiredCertifications: [...requiredCertifications, newCertification]});
    setItemChanged(!itemChanged);
  };

  const removeCertification = useCallback((certificationId) => {
    setCurrentItem({
      ...currentItem,
      requiredCertifications: requiredCertifications.filter(item => item.id !== certificationId)
    });
    setItemChanged(!itemChanged);
  }, [requiredCertifications, currentItem, setCurrentItem, setItemChanged, itemChanged]);

  return (
    <section className="position-requirement-card">
      <button
        type="button"
        className="position-requirement-card-header"
        onClick={() => setIsAccordionOpen(value => !value)}
      >
        <span className="position-requirement-card-title">
          <FontAwesomeIcon icon={faCertificate}/>
          <span>Wymagane certyfikaty</span>
          <span className="position-requirement-count">{requiredCertifications.length}</span>
        </span>
        <FontAwesomeIcon icon={isAccordionOpen ? faChevronUp : faChevronDown}/>
      </button>

      {isAccordionOpen && (
        <div className="position-requirement-card-body" id="requiredCertifications">
          <div className="position-requirement-card-toolbar">
            <span>Wskaż certyfikaty lub zaświadczenia wymagane do pracy na tym stanowisku.</span>
            <button type="button" className="btn btn-sm btn-outline-primary" onClick={addCertification}>
              <FontAwesomeIcon icon={faCirclePlus}/> Dodaj
            </button>
          </div>

          <div className="position-requirement-list">
            {requiredCertifications.length > 0 ? requiredCertifications.map((certification, index) => (
              <PositionCertification
                key={certification.id ?? index}
                index={index}
                state={state}
                certificationsList={filteredCertificationsList}
                onRemove={() => removeCertification(certification.id)}
              />
            )) : (
              <div className="position-requirement-empty">Brak wymaganych certyfikatów</div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default PositionCertificationsCard;
